import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVideocam = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M2.66665 13.3333C2.29998 13.3333 1.98609 13.2027 1.72498 12.9416C1.46387 12.6805 1.33331 12.3666 1.33331 12V3.99996C1.33331 3.63329 1.46387 3.3194 1.72498 3.05829C1.98609 2.79718 2.29998 2.66663 2.66665 2.66663H10.6666C11.0333 2.66663 11.3472 2.79718 11.6083 3.05829C11.8694 3.3194 12 3.63329 12 3.99996V6.99996L14.6666 4.33329V11.6666L12 8.99996V12C12 12.3666 11.8694 12.6805 11.6083 12.9416C11.3472 13.2027 11.0333 13.3333 10.6666 13.3333H2.66665Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgVideocam);
export default ForwardRef;
